import { t } from "../../translations";

import { Aa } from "../functions/Aa";
import "../styles/section-chef.css";

import { TiDelete } from "react-icons/ti";

import { useState } from "react";
import { UPDATE } from "../constants/request-type";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { decryptSingleData } from "../functions/cryptojs";

import { CircularProgress, Dialog } from "@mui/material";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { POST_USER_DATA } from "../../store/action";
import { openNotificationWithIcon } from "./notification-bar";

import { createLogger } from "../../utils/logger";
import AddressDialogForm from "./address-dialog-form";

const logger = createLogger("SelectProfilUser");

const SelectProfilUser = (props) => {
  const { address, setAddress, profil, setProfil, user, lang } = props;

  const [load, setLoad] = useState(false);

  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();

  const post_user_data = (data) => {
    dispatch(post_user(data));
  };

  async function handleConvert(text) {
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          text
        )}&key=${process.env.REACT_APP_API_KEY_MAP}`
      );
      const data = await response.json();

      if (data.results && data.results.length > 0) {
        const { lat, lng } = data.results[0].geometry.location;
        setAddress({ ...address, street_name: text, lat, lng });
        logger.log("Done");
      } else {
        setAddress({ ...address, lat: null, lng: null });
        logger.log("Not Done");
      }
    } catch (error) {
      logger.error("Error:", error);
      setAddress({ ...address, lat: null, lng: null });
      logger.log("Not Done");
    }
  }

  useEffect(() => {}, []);

  const saveUpdate = async () => {
    setLoad(true);

    const request_details = {
      type: UPDATE,
      url: service_api,
      route: `user/update-user/${user?._id}`,
      data: {
        firstname: profil?.firstname,
        lastname: profil?.lastname,
        email: profil?.email,
        number: profil?.number
      },
      token: user?.refresh_token
    };

    try {
      const response = await MakeRequestAsync(request_details);
      const decryptedData = decryptSingleData(response.data.user);
      post_user_data({
        ...decryptedData
      });
    } catch (err) {
      logger.log("We couldn't fetch data: ", err?.response?.data?.message);
      return openNotificationWithIcon(
        "error",
        t("errors.profile_update_error", lang)
      );
    } finally {
      setLoad(false);
    }
  };

  const addressUpdate = async (number) => {
    setLoad(true);

    const request_details = {
      type: UPDATE,
      url: service_api,
      route: `user/update-user/${user?._id}`,
      data: {
        address: user?.address?.filter((item, index) => {
          return index !== number;
        })
      },
      token: user?.refresh_token
    };

    try {
      const response = await MakeRequestAsync(request_details);
      const decryptedData = decryptSingleData(response.data.user);
      post_user_data({
        ...decryptedData
      });
    } catch (err) {
      logger.log("We couldn't fetch data: ", err?.response?.data?.message);
      return openNotificationWithIcon(
        "error",
        t("errors.profile_update_error", lang)
      );
    } finally {
      setLoad(false);
    }
  };

  const addAddress = async () => {
    if (
      address?.receiver_name.length === 0 ||
      address?.phone_number.length === 0 ||
      address?.street_name.length === 0 ||
      address?.line_address.length === 0 ||
      address?.instruction.length === 0
    ) {
      return openNotificationWithIcon(
        "error",
        t("validation.fill_up_all_fie_2", lang)
      );
    }

    if (address?.lat === null || address?.lng === null) {
      return openNotificationWithIcon(
        "error",
        t("errors.address_position_error", lang)
      );
    }

    setLoad(true);

    const request_details = {
      type: UPDATE,
      url: service_api,
      route: `user/update-user/${user?._id}`,
      data: {
        address: [...user?.address, address]
      },
      token: user?.refresh_token
    };

    try {
      const response = await MakeRequestAsync(request_details);
      const decryptedData = decryptSingleData(response.data.user);
      post_user_data({
        ...decryptedData
      });
      // Reset address form
    } catch (err) {
      logger.log("We couldn't fetch data: ", err?.response?.data?.message);
      return openNotificationWithIcon(
        "error",
        t("errors.profile_update_error", lang)
      );
    } finally {
      setAddress({
        receiver_name: "",
        phone_number: "",
        street_name: "",
        line_address: "",
        instruction: "",
        lat: null,
        lng: null
      });
      setOpen(false); // Close the dialog
      setLoad(false);
    }
  };

  return (
    <div className="section-chef-menu-right-profil">
      <div className="section-chef-menu-right-profil-inside">
        <div
          className="section-chef-menu-right-profil-inside-box"
          style={{
            marginTop: 50
          }}
        >
          <div className="section-chef-menu-right-profil-inside-left">
            <p>{t("profile.profile", lang)}</p>
            <p
              style={{
                fontSize: 15
              }}
            >
              {t("buttons.edit_your_infor", lang)}{" "}
            </p>

            <div
              style={{
                width: "97%",
                border: "1px solid #eeeeee",
                padding: 10,
                borderRadius: 5,
                marginTop: 15
              }}
            >
              <p
                style={{
                  fontSize: 16,
                  fontWeight: "600"
                }}
              >
                {t("common.personnal_infor", lang)}{" "}
              </p>
              {[
                {
                  placeholder: t("common.enter_your_firs", lang),
                  name: "firstname",
                  type: "text",
                  disabled: false,
                  value: profil?.firstname,
                  onChange: (e) =>
                    setProfil({
                      ...profil,
                      firstname: e.target.value
                    })
                },
                {
                  placeholder: t("common.enter_your_last", lang),
                  name: "lastname",
                  type: "text",
                  disabled: false,
                  value: profil?.lastname,
                  onChange: (e) =>
                    setProfil({
                      ...profil,
                      lastname: e.target.value
                    })
                },
                {
                  placeholder: t("common.enter_your_emai", lang),
                  name: "email",
                  type: "text",
                  disabled: true,
                  value: profil?.email,
                  onChange: (e) =>
                    setProfil({
                      ...profil,
                      email: e.target.value
                    })
                },
                {
                  placeholder: t("common.enter_your_phon", lang),
                  name: "number",
                  type: "number",
                  disabled: false,
                  value: profil?.number,
                  onChange: (e) =>
                    setProfil({
                      ...profil,
                      number: e.target.value
                    })
                }
              ]?.map((item) => (
                <div
                  onClick={() => {}}
                  style={{
                    width: "100%"
                  }}
                >
                  <input
                    className="select-address-box"
                    style={{
                      backgroundColor: "#eeeeee",
                      opacity: item?.disabled === true ? 0.5 : 1,
                      paddingLeft: 10,
                      borderRadius: 40,
                      height: 40
                    }}
                    disabled={item?.disabled}
                    placeholder={item?.placeholder}
                    type={item?.type}
                    name={item?.name}
                    value={item?.value}
                    onChange={(e) => {
                      item?.onChange(e);
                    }}
                  />
                </div>
              ))}
              <div
                className="btn-get-started"
                style={{
                  backgroundColor: "#ff114d",
                  width: "100%"
                }}
                onClick={() => {
                  if (load) {
                    return;
                  }
                 
                  return saveUpdate();
                }}
              >
                {!load && t("buttons.save_8", lang)}
                {load && <CircularProgress size={25} />}
              </div>
            </div>
          </div>

          <div className="section-chef-menu-right-profil-inside-right">
            <p>{t("buttons.delivery_addres", lang)}</p>
            <p
              style={{
                fontSize: 15
              }}
            >
              {t("buttons.manage_address", lang)}
            </p>
            <div
              style={{
                width: "97%",
                border: "1px solid #eeeeee",
                padding: 10,
                borderRadius: 5,
                marginTop: 15
              }}
            >
              <p
                style={{
                  fontSize: 16,
                  fontWeight: 600
                }}
              >
                {t("buttons.my_address", lang)}
              </p>
              <div
                className="btn-get-started"
                style={{
                  backgroundColor: "#fff",
                  color: "#000",
                  border: "1px solid #cecece",
                  height: 35,
                  maxWidth: 100
                }}
                onClick={() => {
                  if (load) {
                    return;
                  }

                  if (user?.address?.length === 5) {
                    return openNotificationWithIcon(
                      "error",
                      t("buttons.max_address_is__2", lang)
                    );
                  }

                  setOpen(true);
                }}
              >
                {!load && t("buttons.add_4", lang)}
                {load && <CircularProgress size={25} />}
              </div>
              {user?.address?.map((item, index) => (
                <div
                  key={index}
                  style={{
                    width: "100%",
                    border: "1px solid #cecece",
                    marginTop: 10,
                    borderRadius: 30,
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    gap: 5,
                    padding: 10
                  }}
                >
                  <div
                    style={{
                      marginTop: 5
                    }}
                    className="profil-delete-btn"
                    onClick={() => {
                      return addressUpdate(index);
                    }}
                  >
                    <TiDelete size={30} color={"#ff114d"} />
                  </div>
                  <span>{Aa(item?.phone_number)},</span>
                  <span>{Aa(item?.street_name)},</span>
                  <span>{Aa(item?.line_address)},</span>
                  <span>{Aa(item?.instruction)}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div
          style={{
            height: 50
          }}
        ></div>
      </div>
      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <AddressDialogForm
          titleKey="buttons.add_an_address_4"
          descriptionKey="buttons.add_a_delivery__4"
          buttonTextKey="buttons.add_4"
          address={address}
          setAddress={setAddress}
          handleConvert={handleConvert}
          onSubmit={addAddress}
          loading={load}
          lang={lang}
          containerStyle={{ maxWidth: 500, height: "100%" }}
        />
      </Dialog>
    </div>
  );
};

export default SelectProfilUser;

const post_user = (data) => ({
  type: POST_USER_DATA,
  data: data
});
